<script setup lang="ts">
import type { BaseContent, File } from "@gasparigit/omnia-sdk";
import { VuePDF } from "@tato30/vue-pdf";
import { AlertTriangleIcon } from "lucide-vue-next";
import { getDocument, GlobalWorkerOptions, type PDFDocumentLoadingTask } from "pdfjs-dist";
import PDFWorker from "pdfjs-dist/build/pdf.worker.min?url";

const props = defineProps<{
  content: BaseContent;
  file: File;
}>();

const loading = ref(true);
const error = ref(false);

const pdf = ref<{
  pdf?: PDFDocumentLoadingTask;
  pages?: number;
}>({});

async function loadPDF() {
  GlobalWorkerOptions.workerSrc = PDFWorker;
  try {
    const response = await useOmniaSdk().v1.media.downloadFile(props.content.id, props.file.id, true);

    const loadingTask = getDocument({ data: await response.arrayBuffer() });
    loadingTask.promise
      .then((doc) => {
        pdf.value.pdf = doc.loadingTask;
        pdf.value.pages = doc.numPages;
        loading.value = false;
      })
      .catch((e) => {
        loading.value = false;
        error.value = true;
      });
  } catch (e) {
    loading.value = false;
    error.value = true;
  }
}

loadPDF();
</script>

<template>
  <Skeleton class="h-52 rounded-xl" v-if="loading" />
  <ScrollArea v-if="!error" class="bg-gray-50 rounded-xl" style="height: 60rem" :class="loading && 'hidden'">
    <div class="grid gap-3 p-5 place-items-center">
      <template v-for="page in pdf.pages">
        <VuePDF :pdf="pdf.pdf" :page="page" class="shadow-md" />
      </template>
    </div>
  </ScrollArea>
  <Alert variant="info" v-else>
    <AlertTriangleIcon class="w-5 h-5 flex-shrink-0" />
    <AlertTitle>Impossibile caricare l'anteprima</AlertTitle>
    <AlertDescription>Il file non presenta un formato compatibile per la generazione dell'anteprima</AlertDescription>
  </Alert>
</template>
